import { dynamic } from '#/utils/dynamic';

export const cmsModalComponentByType = {
  SUBSCRIBED_TO_SUBSITE: dynamic(
    () =>
      import('#/modules/cms/components/SubscribedToSubsiteModal/SubscribedToSubsiteModal').then(
        (module) => ({ default: module.SubscribedToSubsiteModal }),
      ),
    { strategy: 'always' },
  ),
  JOIN_MOVEMENT: dynamic(
    () =>
      import('#/modules/cms/components/JoinMovementModal/JoinMovementModal').then(
        (module) => ({ default: module.JoinMovementModal }),
      ),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
